import React from 'react';
import AppIcon from '../AppIcon';
import './WebsiteDisplayItem.css';

/**
 * 紧凑显示组件 - 垂直排列（图标在上，标题在下）
 */
const CompactWebsiteDisplay = ({ 
  app, 
  iconSize, 
  iconRadius, 
  iconTextColor,
  onImageError
}) => {
  return (
    <div className="website-display-compact">
        <AppIcon 
          ico={app.ico}
          iconUrl={app.iconUrl}
          textIcon={app.textIcon}
          bgColor={app.bgColor}
          preferredIconType={app.preferredIconType}
          iconColor={app.iconColor || 'white'}
          onImageError={onImageError}
          size={iconSize}
          wrapperStyle={{ 
            borderRadius: `${iconRadius}px`,
            width: `${iconSize}px`,
            height: `${iconSize}px`
          }}
        />
      <div className="compact-title" style={{ color: iconTextColor }}>
        {app.name}
      </div>
    </div>
  );
};

/**
 * 详情显示组件 - 水平排列（左边图标，右边标题和描述）
 */
const DetailedWebsiteDisplay = ({ 
  app, 
  iconSize, 
  iconRadius, 
  iconTextColor,
  onImageError
}) => {
  // 在详情模式下使用更小的图标
  const detailedIconSize = Math.max(iconSize * 0.7, 34);
  
  return (
    <div className="website-display-detailed">
      <div className="detailed-icon-wrapper">
        <AppIcon 
          ico={app.ico}
          iconUrl={app.iconUrl}
          textIcon={app.textIcon}
          bgColor={app.bgColor}
          preferredIconType={app.preferredIconType}
          iconColor={app.iconColor || 'white'}
          onImageError={onImageError}
          size={detailedIconSize}
          wrapperStyle={{ 
            borderRadius: `${iconRadius}px`,
            width: `${detailedIconSize}px`,
            height: `${detailedIconSize}px`
          }}
        />
      </div>
      <div className="detailed-content">
        <div className="detailed-title" style={{ color: iconTextColor }}>
          {app.name}
        </div>
        <div className="detailed-description" style={{ color: iconTextColor }}>
          {app.description || '暂无描述'}
        </div>
      </div>
    </div>
  );
};

/**
 * 根据显示模式选择对应的组件
 */
const WebsiteDisplayItem = ({ 
  displayMode = 'compact',
  app,
  iconSize,
  iconRadius,
  iconTextColor,
  onImageError,
  onContextMenu,
  onClick,
  children
}) => {
  const displayContent = displayMode === 'detailed' ? (
    <DetailedWebsiteDisplay
      app={app}
      iconSize={iconSize}
      iconRadius={iconRadius}
      iconTextColor={iconTextColor}
      onImageError={onImageError}
    />
  ) : (
    <CompactWebsiteDisplay
      app={app}
      iconSize={iconSize}
      iconRadius={iconRadius}
      iconTextColor={iconTextColor}
      onImageError={onImageError}
    />
  );

  return (
    <div 
      style={{
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        overflow: displayMode === 'detailed' ? 'visible' : 'hidden'
      }}
      onContextMenu={onContextMenu}
      onClick={onClick}
    >
      {children}
      {displayContent}
    </div>
  );
};

export default WebsiteDisplayItem;
